<div style="height: 100vh; display: flex; flex-direction: row; place-content: center; align-items: center">
  <div style="flex: 1 1 100%; display: flex; flex-direction: row; place-content: center; align-items: center" >
    <mat-spinner></mat-spinner>
  </div>
</div>

